export default __webpack_public_path__ + "static/media/user.513e3b54.png";